import React from 'react'
import Mailto from 'react-protected-mailto'

export default () => (
  <Mailto
    email='support@remente.com'
    headers={ { subject:'Question from the website' } }
  />
)
